import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {useGetOfferDetailApplicationQuery} from "../../../../offer/api/get_offer_detail";
import {useAppSelector} from "../../../../store/hooks";
import {useGetVendorDetailApplicationQuery} from "../../../../vendor/api/get_vendor_detail_application_api";
import {useUnlockChoiceLeadFlow} from "../../../hooks/use_unlock_choice_lead_flow";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint} from "../../../types/UnlockChoiceEntryPoint";
import {UnlockChoiceModalLayout} from "./UnlockChoiceModalLayout";

interface IProps {
    entryPoint: UnlockChoiceEntryPoint;
    data: IUnlockChoiceData | null;
    zIndex?: number;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onFinishedWithoutLead: () => void;
    onClose: () => void;
}

export const UnlockChoiceModal = (props: IProps) => {
    const {entryPoint, data, zIndex} = props;
    const flow = useUnlockChoiceLeadFlow(props);
    const offerId = useAppSelector((state) => state.registrationFlow.offerId);
    const {data: vendorDetail} = useGetVendorDetailApplicationQuery(data?.vendorId as number, {skip: !data?.vendorId});
    const {data: offerDetail} = useGetOfferDetailApplicationQuery(offerId as number, {skip: !offerId});
    const vendorPrivacyPolicyUrl =
        vendorDetail?.configuration.privacy_policy_file ||
        offerDetail?.configuration.privacy_policy_url ||
        vendorDetail?.configuration.privacy_policy_url ||
        null;
    const hasOfferPersonalDataProcessor = !!offerDetail?.configuration.personal_data_processor_name && !!offerDetail.configuration.personal_data_processor_url;
    const vendorName = hasOfferPersonalDataProcessor
        ? `${offerDetail.configuration.personal_data_processor_name} - Przedstawiciel Dewelopera`
        : vendorDetail?.name || data?.vendorName || null;
    const privacyPolicyUrl = hasOfferPersonalDataProcessor ? offerDetail.configuration.personal_data_processor_url : vendorPrivacyPolicyUrl;

    return (
        <UnlockChoiceModalLayout
            isOpen={flow.isOpen}
            isLoading={!data}
            entryPoint={entryPoint}
            firstName={flow.firstName}
            price={data?.price ?? null}
            offerType={data?.offerType ?? null}
            vendorName={vendorName}
            privacyPolicyUrl={privacyPolicyUrl}
            options={flow.options}
            selectedOptionId={flow.selectedOptionId}
            isSending={flow.isSending}
            isConfirmDisabled={flow.isConfirmDisabled}
            confirmation={flow.confirmation}
            reservation={flow.reservation}
            isPriceNegotiationShown={flow.isPriceNegotiationShown}
            isPriceNegotiationArmed={flow.isPriceNegotiationArmed}
            onSelectOption={flow.handleSelectOption}
            onConfirm={flow.handleConfirm}
            onClose={flow.handleClose}
            onAfterClose={flow.handleAfterClose}
            zIndex={zIndex}
        />
    );
};
import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {useGetOfferDetailApplicationQuery} from "../../../../offer/api/get_offer_detail";
import {useAppSelector} from "../../../../store/hooks";
import {useGetVendorDetailApplicationQuery} from "../../../../vendor/api/get_vendor_detail_application_api";
import {useUnlockChoiceLeadFlow} from "../../../hooks/use_unlock_choice_lead_flow";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint} from "../../../types/UnlockChoiceEntryPoint";
import {UnlockChoiceModalLayout} from "./UnlockChoiceModalLayout";

interface IProps {
    entryPoint: UnlockChoiceEntryPoint;
    data: IUnlockChoiceData | null;
    zIndex?: number;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onFinishedWithoutLead: () => void;
    onClose: () => void;
}

export const UnlockChoiceModal = (props: IProps) => {
    const {entryPoint, data, zIndex} = props;
    const flow = useUnlockChoiceLeadFlow(props);
    const offerId = useAppSelector((state) => state.registrationFlow.offerId);
    const {data: vendorDetail} = useGetVendorDetailApplicationQuery(data?.vendorId as number, {skip: !data?.vendorId});
    const {data: offerDetail} = useGetOfferDetailApplicationQuery(offerId as number, {skip: !offerId});
    const vendorPrivacyPolicyUrl =
        vendorDetail?.configuration.privacy_policy_file ||
        offerDetail?.configuration.privacy_policy_url ||
        vendorDetail?.configuration.privacy_policy_url ||
        null;
    const hasOfferPersonalDataProcessor = !!offerDetail?.configuration.personal_data_processor_name && !!offerDetail.configuration.personal_data_processor_url;
    const vendorName = hasOfferPersonalDataProcessor
        ? `${offerDetail.configuration.personal_data_processor_name} - Przedstawiciel Dewelopera`
        : vendorDetail?.name || data?.vendorName || null;
    const privacyPolicyUrl = hasOfferPersonalDataProcessor ? offerDetail.configuration.personal_data_processor_url : vendorPrivacyPolicyUrl;

    return (
        <UnlockChoiceModalLayout
            isOpen={flow.isOpen}
            isLoading={!data}
            entryPoint={entryPoint}
            firstName={flow.firstName}
            price={data?.price ?? null}
            offerType={data?.offerType ?? null}
            vendorName={vendorName}
            privacyPolicyUrl={privacyPolicyUrl}
            options={flow.options}
            selectedOptionId={flow.selectedOptionId}
            isSending={flow.isSending}
            isConfirmDisabled={flow.isConfirmDisabled}
            confirmation={flow.confirmation}
            reservation={flow.reservation}
            isPriceNegotiationShown={flow.isPriceNegotiationShown}
            isPriceNegotiationArmed={flow.isPriceNegotiationArmed}
            onSelectOption={flow.handleSelectOption}
            onConfirm={flow.handleConfirm}
            onClose={flow.handleClose}
            onAfterClose={flow.handleAfterClose}
            zIndex={zIndex}
        />
    );
};
